<div class="rail-layout" [attr.data-density]="density">

  <!-- Shell chrome, inherited from 3a — 1c was a static mock and had none. -->
  <div class="rail-layout__titlebar" (pointerdown)="onTitleBarPointerDown($event)">
    <div class="rail-layout__dots" aria-hidden="true"><span></span><span></span></div>
    <div class="rail-layout__wordmark">BUDDY</div>
    <div class="rail-layout__chrome">
      <button type="button" class="rail-layout__chrome-btn" [attr.aria-label]="collapseStyleLabel" [attr.title]="collapseStyleLabel" (click)="onToggleCollapseStyle()">{{ useEdgeTab ? '●' : '▐' }}</button>
      <button type="button" class="rail-layout__chrome-btn" aria-label="Switch to the stacked panel layout" (click)="layoutToggleRequested.emit()">▤</button>
      <button type="button" class="rail-layout__chrome-btn" aria-label="Snap to the other edge" (click)="edgeToggleRequested.emit()">⇱</button>
      <button type="button" class="rail-layout__chrome-btn" aria-label="Collapse Buddy" (click)="collapseRequested.emit()">▭</button>
    </div>
  </div>

  <div class="rail-layout__body">

    <!-- 34px icon rail: streak + workflows, so chat keeps the full width. -->
    <nav class="rail" aria-label="Streak and workflows">
      <!-- Deviation from 1c: BB carries the state machine, so he needs to be visible. -->
      <app-bb-mascot [state]="bbState" [stage]="progress.stage" [size]="22"></app-bb-mascot>

      <button
        type="button"
        class="rail__streak"
        [style.background]="ringBackground"
        [attr.aria-label]="progress.streakDays + ' day streak, ' + progress.multiplier + ' times XP — open BB’s habitat'"
        (click)="onOpenHabitat()"
      >
        <span class="rail__streak-inner">{{ progress.streakDays }}</span>
      </button>

      <span class="rail__divider" aria-hidden="true"></span>

      <!-- History lives in the rail here, which is its natural home in this layout. -->
      <button type="button" class="rail__icon rail__icon--history" aria-label="Chat history (Ctrl+J)" title="Chat history · Ctrl+J" (click)="onToggleHistory()">☰</button>

      <button
        type="button"
        class="rail__icon"
        *ngFor="let workflow of railWorkflows; trackBy: trackWorkflow"
        [style.color]="glyphColor(workflow)"
        [attr.aria-label]="workflow.name + ' — ' + workflow.description"
        (pointerdown)="onIconDown(workflow)"
        (pointerup)="onIconUp(workflow)"
        (pointerleave)="onIconCancel()"
        (pointercancel)="onIconCancel()"
        (keydown.enter)="onRunWorkflow(workflow.id)"
      >
        {{ workflow.glyph }}
      </button>

      <button
        type="button"
        class="rail__icon rail__icon--add"
        aria-label="More workflows, or define a new one"
        (click)="onTogglePalette()"
      >
        ＋
      </button>

      <span class="rail__spacer"></span>

      <button type="button" class="rail__icon rail__icon--badges" aria-label="Badges and progress" (click)="onOpenHabitat()">
        ★
      </button>
    </nav>

    <!-- Chat column -->
    <div class="rail-main">

      <!-- Daily quest — one line + 4px bar, dismissible for the day (1d). -->
      <div class="quest" *ngIf="questVisible">
        <div class="quest__head">
          <span class="quest__title">Daily quest</span>
          <span class="quest__count">{{ progress.quest.done }}/{{ progress.quest.total }}</span>
          <button type="button" class="quest__dismiss" aria-label="Dismiss today’s quest" (click)="dismissQuest()">✕</button>
        </div>
        <p class="quest__body">{{ progress.quest.label }}</p>
        <div class="quest__track" role="progressbar" [attr.aria-valuenow]="questPct" aria-valuemin="0" aria-valuemax="100">
          <div class="quest__fill" [style.width.%]="questPct"></div>
        </div>
      </div>

      <div class="rail-main__body">
        <app-buddy-chat-log
          [messages]="messages"
          [runs]="runs"
          [speakingMessageId]="speakingMessageId"
          (cancelRun)="onCancelRun($event)"
          (retryRun)="onRetryRun($event)"
          (decideRun)="onDecideRun($event)"
          (stopTts)="onStopTts()"
          (suggestionPicked)="onSuggestion($event)"
        ></app-buddy-chat-log>

        <app-buddy-workflow-palette
          *ngIf="paletteOpen"
          [workflows]="paletteWorkflows"
          [query]="paletteQuery"
          (runRequested)="onRunWorkflow($event)"
          (paramsRequested)="onWorkflowParams($event)"
          (defineRequested)="onDefineWorkflow()"
          (closed)="onClosePalette()"
        ></app-buddy-workflow-palette>

        <app-buddy-habitat
          *ngIf="habitatOpen"
          [progress]="progress"
          [bbState]="bbState"
          (closed)="onCloseHabitat()"
        ></app-buddy-habitat>

        <!-- Drawer covers the chat column only; the 34px rail stays as nav. -->
        <app-buddy-history *ngIf="historyOpen" (closed)="onCloseHistory()"></app-buddy-history>
      </div>

      <!-- 1c's input row: field + mic only. -->
      <app-buddy-input-row
        [ttsEnabled]="ttsEnabled"
        [micActive]="micActive"
        [handsFree]="handsFree"
        [streaming]="streaming"
        [transcript]="transcript"
        [showTtsToggle]="false"
        micVariant="tinted"
        placeholder="/ or type…"
        (submitted)="onSubmit($event)"
        (queryChanged)="onQueryChanged($event)"
        (micToggled)="onMicToggled()"
        (micHeld)="onMicHeld()"
        (ttsToggled)="onTtsToggled()"
        (stopRequested)="onStopStream()"
      ></app-buddy-input-row>
    </div>
  </div>
</div>
